import { Module } from '@nestjs/common'
import { CustomerOrderController, OrderController } from './controllers'
import { OrderEmailService, OrderService } from './services'

@Module({
	controllers: [OrderController, CustomerOrderController],
	providers: [OrderService, OrderEmailService],
})
export class OrderModule {}
